import React, { useEffect, useMemo, useRef, useState } from "react";
import Button from "../ui/Button";
import Input from "../ui/Input";
import { useTable } from "./Table";
import useUpdateEffect from "../../hooks/useUpdateEffect";
import { createPortal } from "react-dom";
import { useSelector } from 'react-redux';
import Loading from "../Loading";

const Cell = ({ row, col,tableName }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editId,setEditid] = useState('');
  const schools = useSelector((state) => state.schools.data);
  const editBtn = useRef();

  const { onEdit,status } = useTable();

  useEffect(()=>{
    if (status.edit === 'idle') {
      setEditid('');
    }
  },[status.edit])

  const renderContent = () => {
    if (col.key === "voted") {
      return Number(row[col.key]) === 1 ? "Voted" : "Not Voted";
    }

    if (col.key === "sbisd_voted") {
      if (row[col.key] === '1') {
        return 'Voted'
      } else if (row[col.key] === '0') {
        return 'Not Voted'
      } else {
        return 'N/A'
      }
    }

    if (
      col.key === "phone_number" &&
      row[col.key] &&
      row[col.key] !== "missing"
    ) {
      const str = row[col.key].toString();

      return (
        <a href={`tel:+1${str}`} className="underline">
          {str.slice(0, 3) + "-" + str.slice(3, 6) + "-" + str.slice(6)}
        </a>
      );
    }

    if (
      col.key === "user_email" &&
      row[col.key] &&
      row[col.key] !== "missing"
    ) {
      const str = row[col.key];

      return (
        <a href={`mailto:${str}`} className="underline">
          {str}
        </a>
      );
    }

    if (col.key === "timestamp_epoch" && row[col.key]) {
      const date = new Date(+row[col.key]); // Create a Date object from the timestamp

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
      const day = String(date.getDate()).padStart(2, "0");

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    if (col.isJson) {
      return <JsonCell row={row} col={col} />;
    }

    if (col.key === 'primary_voting_history'  && row[col.key] !== 'missing') {
      let items = row[col.key]?.split(",")?.slice(0,4).map(item => item || "-").concat(Array(4 - (row[col.key]?.split(",")?.slice(0,4).length || 0)).fill("-")) || []
      function getTooltipName(index) {
        switch (index) {
          case 0:
            return "Mar 2023";
          case 1:
            return "Mar 2021";
          case 2:
            return "Mar 2019";
          case 3:
            return "Mar 2017";
          default:
            return "";
        }
      }
      
      return (
        <div className="flex gap-2 p-4 rounded-lg">
          {items.map((item, index) => (
            <div key={index}>
              {/* Main Box */}
              <div 
                className="
                border border-gray-300 rounded-[3px] px-4 py-2 text-lg hover:bg-gray-200 h-[30px] w-[30px]
                flex items-center justify-center p-2 cursor-pointer text-[#313131] hover:bg-gray relative z-[2] data-[tooltip]:after:content-[attr(data-tooltip)] data-[tooltip]:after:mt-2 data-[tooltip]:after:text-sm data-[tooltip]:after:invisible data-[tooltip]:after:scale-50 data-[tooltip]:after:origin-top data-[tooltip]:after:opacity-0 hover:data-[tooltip]:after:visible hover:data-[tooltip]:after:opacity-100 hover:data-[tooltip]:after:scale-100 data-[tooltip]:after:transition-all data-[tooltip]:after:absolute data-[tooltip]:after:bg-white data-[tooltip]:after:top-[calc(100%+4px)] data-[tooltip]:after:left-1/2 data-[tooltip]:after:-translate-x-1/2 data-[tooltip]:after:-z-[1] data-[tooltip]:after:px-2.5 data-[tooltip]:after:py-1 data-[tooltip]:after:min-h-fit data-[tooltip]:after:min-w-fit data-[tooltip]:after:rounded-md data-[tooltip]:after:drop-shadow data-[tooltip]:before:mt-2 data-[tooltip]:before:drop-shadow data-[tooltip]:after:text-center data-[tooltip]:after:text-zinc-800 data-[tooltip]:after:whitespace-nowrap data-[tooltip]:after:text-[10px] data-[tooltip]:before:invisible data-[tooltip]:before:opacity-0 hover:data-[tooltip]:before:visible hover:data-[tooltip]:before:opacity-100 data-[tooltip]:before:transition-all data-[tooltip]:before:bg-white data-[tooltip]:before:[clip-path:polygon(50%_0,0_100%,100%_100%)] data-[tooltip]:before:absolute data-[tooltip]:before:top-full data-[tooltip]:before:left-1/2 data-[tooltip]:before:-translate-x-1/2 data-[tooltip]:before:z-0 data-[tooltip]:before:w-3 data-[tooltip]:before:h-[4px]
                "
                data-tooltip={getTooltipName(index)}
              >
                {item}
              </div>
              {/* Tooltip for each item */}
            </div>
          ))}
        </div>
      )
    }

    if (col.key === 'general_voting_history' && row[col.key] !== 'missing') {
      let items = row[col.key]?.split(",")?.slice(0,4).map(item => item || "-").concat(Array(4 - (row[col.key]?.split(",")?.slice(0,4).length || 0)).fill("-")) || []
      function getTooltipName(index) {
        switch (index) {
          case 0:
            return "Nov 2024";
          case 1:
            return "Nov 2022";
          case 2:
            return "Nov 2020";
          case 3:
            return "Nov 2018";
          default:
            return "";
        }
      }
      
      return (
        <div className="flex gap-2 p-4 rounded-lg">
          {items.map((item, index) => (
            <div key={index}>
              {/* Main Box */}
              <div 
                className="
                border border-gray-300 rounded-[3px] px-4 py-2 text-lg hover:bg-gray-200 h-[30px] w-[30px]
                flex items-center justify-center p-2 cursor-pointer text-[#313131] hover:bg-gray relative z-[2] data-[tooltip]:after:content-[attr(data-tooltip)] data-[tooltip]:after:mt-2 data-[tooltip]:after:text-sm data-[tooltip]:after:invisible data-[tooltip]:after:scale-50 data-[tooltip]:after:origin-top data-[tooltip]:after:opacity-0 hover:data-[tooltip]:after:visible hover:data-[tooltip]:after:opacity-100 hover:data-[tooltip]:after:scale-100 data-[tooltip]:after:transition-all data-[tooltip]:after:absolute data-[tooltip]:after:bg-white data-[tooltip]:after:top-[calc(100%+4px)] data-[tooltip]:after:left-1/2 data-[tooltip]:after:-translate-x-1/2 data-[tooltip]:after:-z-[1] data-[tooltip]:after:px-2.5 data-[tooltip]:after:py-1 data-[tooltip]:after:min-h-fit data-[tooltip]:after:min-w-fit data-[tooltip]:after:rounded-md data-[tooltip]:after:drop-shadow data-[tooltip]:before:mt-2 data-[tooltip]:before:drop-shadow data-[tooltip]:after:text-center data-[tooltip]:after:text-zinc-800 data-[tooltip]:after:whitespace-nowrap data-[tooltip]:after:text-[10px] data-[tooltip]:before:invisible data-[tooltip]:before:opacity-0 hover:data-[tooltip]:before:visible hover:data-[tooltip]:before:opacity-100 data-[tooltip]:before:transition-all data-[tooltip]:before:bg-white data-[tooltip]:before:[clip-path:polygon(50%_0,0_100%,100%_100%)] data-[tooltip]:before:absolute data-[tooltip]:before:top-full data-[tooltip]:before:left-1/2 data-[tooltip]:before:-translate-x-1/2 data-[tooltip]:before:z-0 data-[tooltip]:before:w-3 data-[tooltip]:before:h-[4px]
                "
                data-tooltip={getTooltipName(index)}
              >
                {item}
              </div>
              {/* Tooltip for each item */}
            </div>
          ))}
        </div>
      )
    }

    if (col.key === 'school_district') {
      let index = schools.findIndex((ele)=> row[col.key] == ele.id);
      if (index === -1) {
        return; 
      } else {
        return schools[index].school_district_name
      }
    }

    if (col.key === 'last_activity_at') {
      if (row[col.key]) {
        return new Date(Number(row[col.key]) * 1000).toLocaleDateString('en-US')
      } else {
        return ""
      }
    }

    if (col.key === 'update_last_contacted') {
      function markAsContacted() {
        setEditid(row['id']);
        onEdit(row, {key: 'last_activity_at'}, String(new Date().getTime() / 1000))
      }
      return (
        <button 
          className="flex items-center justify-center font-semibold gap-1 md:gap-3 border h-11 px-2 md:px-3 transition-colors rounded-md text-sm lg:text-[15px] relative disabled:hover:bg-transparent disabled:opacity-60  hover:bg-[#F9F9FA] min-w-full"
          onClick={markAsContacted}
          disabled={status.edit === "loading" && row['id'] === editId}
        >
          {(status.edit === "loading" && row['id'] === editId) ? <Loading size={20}/> : 'Contact Now'}
        </button>
      )
    }

    if (row[col.key]?.toString) return row[col.key].toString();

    return row[col.key];
  };

  return (
    <td
      className={`text-start text-sm lg:text-base first:pl-4 whitespace-nowrap relative group ${
        col.className ? col.className : ""
      } ${isEditing ? "bg-[#f3f3f5] z-10" : (col.key === 'primary_voting_history') ? "" : "hover:bg-[#f3f3f5]"}
      ${(col.key === 'full_name' || col.key === 'last_name' || col.key === 'first_name' || col.key === 'middle_name' || col.key === 'house_number' || col.key === 'street_name') ? 'capitalize' : ''}
      ${(tableName === 'myList' && col.key === 'sbisd_voted') ?  'bg-[#F5F5F5]' : ''}
      ${(tableName === 'myList' && col?.key === 'voted') ?  'bg-[#FFE5E5]' : ''}
      `}
    >
      {renderContent()}

      {col.canEdit && (
        <>
          <div
            ref={editBtn}
            className="h-full absolute right-2 flex items-center top-0"
          >
            <button
              onClick={() => setIsEditing((prev) => !prev)}
              className={`bg-white p-1 rounded-md ${
                isEditing ? "" : "hidden group-hover:block"
              }`}
            >
              <img src="/edit.svg" alt="" className="size-[18px]" />
            </button>
          </div>

          {isEditing && (
            <EditModal
              defaultValue={row[col.key]}
              close={() => setIsEditing(false)}
              onEdit={(value) => onEdit(row, col, value)}
              offsetContainer={editBtn.current}
              callKey={col.key}
              tableName={tableName}
            />
          )}
        </>
      )}
    </td>
  );
};

export default Cell;

const EditModal = ({ defaultValue, close, onEdit, offsetContainer,callKey,tableName }) => {
  const [editValue, setEditValue] = useState(defaultValue);
  const modal = useRef();
  const schools = useSelector((state) => tableName === 'myList' ?  state.schools.data.filter((x)=> x.id == 21) : state.schools.data);

  const { status } = useTable();

  const handleSubmit = (e) => {
    e.preventDefault();
    onEdit(editValue);
  };

  useEffect(() => {
    const { top, left } = offsetContainer.getBoundingClientRect();

    const modalWidth = modal.current.getBoundingClientRect().width;

    if (left < modalWidth) modal.current.style.translate = "30px 0px";
    else modal.current.style.translate = "calc(-100% - 4px) 0px";

    modal.current.style.top = `${window.scrollY + top}px`;
    modal.current.style.left = `${left}px`;
  }, []);

  useUpdateEffect(() => {
    if (status.edit === "idle") close();
  }, [status.edit]);

  return createPortal(
    <>
      <div onClick={close} className="fixed inset-0 z-50"></div>

      <div
        ref={modal}
        className="absolute bg-white border px-3 pb-3 flex flex-col items-end z-50"
      >
        <div className="h-[52px] flex items-center w-full justify-between">
          <h6 className="text-xl font-semibold">Edit Cell</h6>

          <button
            onClick={close}
            className="border size-8 flex justify-center items-center rounded-md"
          >
            <img src="/cross.svg" alt="close" className="size-4" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          {callKey !== 'school_district' ? 
          <Input
            value={editValue}
            onChange={
              (e) => {
                if (callKey === 'pct_ch_no') {
                  const value = e.target.value;
                  if (value === "") {
                    setEditValue(e.target.value)
                    return;
                  }
                  const numberValue = Number(value);
                  if (/^\d+$/.test(value) && numberValue >= 1 && numberValue <= 1152) {
                    setEditValue(e.target.value)
                  } 
                } else {
                  setEditValue(e.target.value)
                }
              }
            }
            placeholder="Enter value here"
            className="!h-11"
          /> : 
            <>
              <div className='relative'>
                <div className="absolute inset-y-0 right-4 flex items-center pl-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <select
                  name="schoolDistrict"
                  className="appearance-none  w-full px-[10px] py-[4px] xs:px-[11px] xs:py-[7px] md:px-[20px] md:py-[11px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl"
                  value={editValue}
                  onChange={(e) => setEditValue(e.target.value)}
                >
                  <option value="">Select</option>
                  {schools.map((option) => (
                    <option key={option.id} value={option.id}>{option.school_district_name}</option>
                  ))}
                </select>
                </div>
            </>
          }

          <div className="flex gap-2 self-end">
            <Button
              type="button"
              onClick={close}
              className="bg-transparent !text-cherry"
            >
              Cancel
            </Button>

            <Button
              type="submit"
              state={status.edit}
              disabled={
                (editValue === "" && (callKey !== 'pct_ch_no' && callKey !== 'school_district')) ||
                editValue === defaultValue ||
                status.edit === "loading" 
              }
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    </>,
    document.querySelector("#root")
  );
};

const JsonCell = ({ row, col }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  let value = JSON.stringify(JSON.parse(row[col.key]), null, 2);

  if (!isExpanded && row[col.key] !== "{}") value = "{...}";

  return (
    <div className={`flex gap-1 ${isExpanded ? "py-3.5" : "py-0"}`}>
      {row[col.key] !== "{}" && (
        <div className="h-5 flex items-center">
          <button
            className="size-5"
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            <img
              src="/chevron-down.svg"
              alt=""
              className={`w-full h-full ${isExpanded ? "" : "-rotate-90"}`}
            />
          </button>
        </div>
      )}

      <pre>{value}</pre>
    </div>
  );
};
